/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useLabels } from '@/hooks/useLabels';
import { useLocale } from '@/hooks/useLocale';
import { Button } from '@az/starc-ui';
import { formatDealExpirationDate } from '../../../utils/formatDealDate';
import type { Deal } from '../../../interface';
import styles from './stylesV2.module.scss';
import { Icon } from '@az/starc-ui';
import { AlarmClock } from '@az/starc-ui-icons';
type Props = {
  deal: Deal;
  onSelect: (deal: Deal) => void;
};

const labelMap = {
  label_deal_bundle_expires: 'label_deal_bundle_expires',
  label_deal_bundle_get_deal: 'label_deal_bundle_get_deal',
};

export const BundleDealOption = ({ deal, onSelect }: Props) => {
  const labels = useLabels(labelMap);
  const { description, expirationDate, id } = deal;
  const locale = useLocale();
  const date = formatDealExpirationDate(expirationDate, locale);

  return (
    <li className={styles.container}>
      <div className={styles.info}>
        <p>{description}</p>
      </div>
      <time className={styles.expiration} dateTime={expirationDate}>
        <Icon svg={AlarmClock} size={4} className={styles.expirationIcon} />
        {labels.label_deal_bundle_expires} {date}
      </time>
      <Button onClick={() => onSelect(deal)} data-testid={`get-deal-button-${id}`}>
        {labels.label_deal_bundle_get_deal}
      </Button>
    </li>
  );
};
